// Clinical dropdown/checkbox options — single source of truth.
// To add/remove a condition or language: edit this file only.

// Values must match ChronicCondition enum in @hcm/core (DRS §2.3)
export const CHRONIC_CONDITIONS = [
  { value: "hypertension",                label: "Hypertension" },
  { value: "diabetes_type2",              label: "Diabetes Type 2" },
  { value: "diabetes_type1",              label: "Diabetes Type 1" },
  { value: "ischaemic_heart_disease",     label: "Ischaemic heart disease" },
  { value: "prior_myocardial_infarction", label: "Prior heart attack (MI)" },
  { value: "heart_failure",               label: "Heart failure" },
  { value: "atrial_fibrillation",         label: "Atrial fibrillation" },
  { value: "stroke_prior",                label: "Prior stroke / TIA" },
  { value: "copd",                        label: "COPD" },
  { value: "asthma",                      label: "Asthma" },
  { value: "chronic_kidney_disease",      label: "Chronic kidney disease" },
  { value: "osteoarthritis",              label: "Osteoarthritis" },
  { value: "osteoporosis",                label: "Osteoporosis" },
  { value: "parkinson_disease",           label: "Parkinson's disease" },
  { value: "dementia_alzheimers",         label: "Dementia / Alzheimer's" },
  { value: "depression",                  label: "Depression" },
  { value: "anxiety_disorder",            label: "Anxiety disorder" },
  { value: "hypothyroidism",              label: "Hypothyroidism" },
  { value: "hyperthyroidism",             label: "Hyperthyroidism" },
  { value: "anaemia",                     label: "Anaemia" },
  { value: "cancer_active",               label: "Cancer (active)" },
  { value: "cancer_remission",            label: "Cancer (remission)" },
  { value: "liver_disease",               label: "Liver disease" },
  { value: "peripheral_vascular_disease", label: "Peripheral vascular disease" },
  { value: "obesity",                     label: "Obesity" },
  { value: "malnutrition_risk",           label: "Malnutrition / risk" },
  { value: "urinary_incontinence",        label: "Urinary incontinence" },
  { value: "benign_prostatic_hyperplasia",label: "Benign prostatic hyperplasia" },
  { value: "cataract_glaucoma",           label: "Cataract / Glaucoma" },
  { value: "hearing_loss",                label: "Hearing loss" },
  { value: "none_known",                  label: "None known" },
  { value: "other",                       label: "Other" },
] as const;

export const PRIMARY_LANGUAGES = [
  // Indian languages first (DRS: lowercase values)
  { value: "hindi",      label: "Hindi" },
  { value: "english",    label: "English" },
  { value: "tamil",      label: "Tamil" },
  { value: "telugu",     label: "Telugu" },
  { value: "kannada",    label: "Kannada" },
  { value: "malayalam",  label: "Malayalam" },
  { value: "marathi",    label: "Marathi" },
  { value: "bengali",    label: "Bengali" },
  { value: "gujarati",   label: "Gujarati" },
  { value: "punjabi",    label: "Punjabi" },
  { value: "urdu",       label: "Urdu" },
  { value: "odia",       label: "Odia" },
  { value: "other",      label: "Other" },
] as const;

export const APPETITE_OPTS = [
  { value: "good", label: "Good" },
  { value: "fair", label: "Fair" },
  { value: "poor", label: "Poor" },
] as const;

// Values match HospitalisationReason type in @hcm/core (DRS §5.2 — 18 categories).
export const HOSP_REASON_OPTS = [
  { value: "",                                  label: "— select —" },
  { value: "cardiac_acute",                     label: "Cardiac — acute" },
  { value: "cardiac_chronic_decompensation",    label: "Cardiac — chronic decompensation" },
  { value: "respiratory_acute",                 label: "Respiratory — acute" },
  { value: "respiratory_chronic_exacerbation",  label: "Respiratory — chronic exacerbation" },
  { value: "stroke_tia",                        label: "Stroke / TIA" },
  { value: "fall_injury",                       label: "Fall with injury" },
  { value: "infection_uti",                     label: "Infection — UTI" },
  { value: "infection_other",                   label: "Infection — other" },
  { value: "diabetic_emergency",                label: "Diabetic emergency" },
  { value: "medication_related",                label: "Medication-related" },
  { value: "gastrointestinal",                  label: "Gastrointestinal" },
  { value: "mental_health_acute",               label: "Mental health — acute" },
  { value: "dehydration_malnutrition",          label: "Dehydration / malnutrition" },
  { value: "cancer_related",                    label: "Cancer-related" },
  { value: "renal",                             label: "Renal" },
  { value: "elective_planned",                  label: "Elective / planned" },
  { value: "unknown",                           label: "Unknown" },
  { value: "other_specify",                     label: "Other (specify)" },
] as const;
